// extracted by mini-css-extract-plugin
export default {"documentButtons":"document_buttons-module___documentButtons___f8446f06"};